import React from "react";
import Sparkline from "./Sparkline";

const CHIP_TONES = {
  up: "bg-[#E8F5EC] text-[#15803D]",
  down: "bg-[#FDECEA] text-[#B42318]",
  flat: "bg-[#F4F1F6] text-[#73607B]",
};

const CARD = "bg-white border border-black/[0.08] rounded-xl shadow-[0_1px_3px_rgba(24,16,28,0.05)] px-[18px] pt-[18px] pb-4 flex flex-col gap-2.5 min-w-0";

export const KpiCardSkeleton = () => (
  <div className={`${CARD} animate-pulse`}>
    <div className="h-4 w-32 rounded bg-[#F1EDF3]" />
    <div className="h-8 w-20 rounded bg-[#F1EDF3]" />
    <div className="h-4 w-40 rounded bg-[#F1EDF3]" />
  </div>
);

// The number and the sparkline share one row; the sparkline shrinks with the card instead of wrapping under it.
const KpiCard = ({ label, value, chip, sub, color, series, delay }) => (
  <div className={CARD}>
    <div className="flex items-center gap-2 min-w-0">
      <span className="w-1 h-4 rounded flex-shrink-0" style={{ background: color }} />
      <span className="text-[14px] font-medium text-[#73607B] truncate">{label}</span>
    </div>
    <div className="flex items-end justify-between gap-3 min-w-0">
      <span className="text-[32px] font-medium leading-none text-[#18101C] tracking-[-0.02em] whitespace-nowrap">{value}</span>
      <Sparkline values={series} color={color} delay={delay} className="h-9 w-24 min-w-[40px] flex-shrink" />
    </div>
    <div className="flex items-center gap-1.5 min-w-0">
      {chip && (
        <span className={`text-[12px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap flex-shrink-0 ${CHIP_TONES[chip.tone]}`}>
          {chip.text}
        </span>
      )}
      {sub && <span className="text-[12px] text-[#8A7A91] truncate" title={sub}>{sub}</span>}
    </div>
  </div>
);

export default KpiCard;
